<template>
    <div>
        <div class="col text-center">
            <h3>เลือกภาษาที่ต้องการ</h3>
            <button  type="button"
                     @click="ChoosLang('th')"
                     class="btn btn-success">
                <icon name="print" style="width: 25px"></icon>
                ไทย
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="ChoosLang('mm')"
                    class="btn btn-success">
                <icon name="print" style="width: 25px"></icon>
                พม่า
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChooseLangModal",
        data(){
            return{
                Lang : ''
            }
        },
        created() {

        },
        methods:{
            ChoosLang(value){
                let data = {
                    Lang : value ? value : '',
                };
                this.$emit("submit",data);
            },
            cancelData(){
                this.$emit("submit",false);
            },
        }
    }
</script>

<style scoped>

</style>
